import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  paddingTop: '642px',
  height: '100%',
  flexDirection: 'column',
  backgroundColor: 'rgba(17, 23, 35, 0.7)'
});

export const wideContainer = css({
  alignItems: 'center',
  width: '279px',
  backgroundColor: 'rgba(17, 23, 35, 0.8)'
});

export const narrowContainer = css({
  width: '91px'
});

export const navContent = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '280px'
});

export const navWideContent = css({
  alignItems: 'flex-start'
});

export const navNarrowContent = css({
  alignItems: 'center'
});
